import React from 'react';
import Experiment from '@homeaway/react-experiment';
import {HA_SERP_NO_RESULTS_URGENCY_MESSAGE} from '../../abacus/experiments';
import SearchBannerContainer from '../SearchBannerContainer/SearchBannerContainer';

export const SearchBannerExperimentWrapper = (props) => {
    const {destinationMessage, hasResults} = props;
    return (
        <Experiment name={HA_SERP_NO_RESULTS_URGENCY_MESSAGE}>
            {({On, Off}) => (
                <React.Fragment>
                    <On>
                        <section className="Application__searchBanner">
                            <SearchBannerContainer
                                urgencyMessage={destinationMessage}
                            />
                        </section>
                    </On>
                    <Off>
                        {hasResults && (
                            <section className="Application__searchBanner">
                                <SearchBannerContainer
                                    urgencyMessage={destinationMessage}
                                />
                            </section>
                        )}
                    </Off>
                </React.Fragment>
            )}
        </Experiment>
    );
};
